import logger from '~/services/logger';
import { getVideoItemParentUrl } from './utils/index.ts';
import { type NavigateFunction, useNavigate } from '@remix-run/react';
import { type FeedEntry } from '~/services/layout/index.ts';

export function AdsBackButton({ playableItem }: { playableItem: FeedEntry }) {
  const navigate: NavigateFunction = useNavigate();

  try {
    return (
      <div
        className="absolute bottom-0 left-0 top-0 flex h-fit w-screen flex-col justify-between bg-gradient-to-b from-black to-transparent p-4"
        style={{
          zIndex: 9999,
        }}
      >
        <span
          onClick={() => {
            const parentUrl: string = getVideoItemParentUrl(playableItem);
            navigate(parentUrl);
          }}
          className="h-10 w-10 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-9 w-9 text-white"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </span>
      </div>
    );
  } catch (error: any) {
    logger.info(`AdsBackButton: ${error.message}`);
    return <></>;
  }
}
